module.exports = __webpack_public_path__ + "static/media/4_person@2x.eaafb7a4.jpg";